import { Text } from '@volkswagen-onehub/components-core';
import React from 'react';

export const formatCopy = (copy: string): JSX.Element[] => {
  const strArr = copy.split(/[{}]/);

  const formattedCopy = strArr.map((substr, i) => {
    const key = `substr-${i}`;
    if (i % 2 === 0) {
      return <React.Fragment key={key}>
        { substr }
      </React.Fragment>;
    } else {
      return <Text bold key={key}>
        { substr }
      </Text>
    }
  });

  return formattedCopy;
};
